import React, { useContext, useState } from "react";

import { Button } from "reactstrap";

import { ProductContext } from "../../../store";

import DetailSkeleton from "../../../components/Skeleton/DetailSkeleton";

import SchemaOptimizerGenerateModal from "../../../components/AiVisibility/SchemaOptimizer/SchemaOptimizerGenerateModal";

import SchemaOptimizerJobsCard from "../../../components/AiVisibility/SchemaOptimizer/SchemaOptimizerJobsCard";



const AiVisibilitySchemaOptimizer = () => {

	const { currentWebsiteId, userLoader, websiteLoader, websiteData } =
		useContext(ProductContext);
	const siteUrl = currentWebsiteId
		? websiteData?.[currentWebsiteId]?.websiteURL
		: null;

	const [generateModalOpen, setGenerateModalOpen] = useState(false);

	const [jobsRefreshKey, setJobsRefreshKey] = useState(0);



	if (userLoader || websiteLoader) {

		return <DetailSkeleton />;

	}



	if (!currentWebsiteId) {

		return (

			<div className="contentBlock ai-visibility-dashboard">

				<p className="text-muted mb-0">Select a website to use Schema Optimizer.</p>

			</div>

		);

	}



	return (

		<div className="contentBlock ai-visibility-dashboard schema-optimizer">

			<div className="schema-optimizer__page-header mb-2">

				<h2 className="schema-optimizer__page-title mb-0">Schema Optimizer</h2>

				<Button

					color="primary"

					className="schema-optimizer__generate-btn"

					onClick={() => setGenerateModalOpen(true)}

				>

					Generate schema

				</Button>

			</div>

			<p className="text-muted schema-optimizer__page-subtitle mb-4">

				Validate, clean, and generate domain-perfect JSON-LD structured data for your pages.

			</p>



			<SchemaOptimizerGenerateModal

				isOpen={generateModalOpen}

				onClose={() => setGenerateModalOpen(false)}

				websiteId={currentWebsiteId}

				websiteUrl={siteUrl}

				onSubmitted={() => setJobsRefreshKey((key) => key + 1)}

			/>



			<SchemaOptimizerJobsCard

				websiteId={currentWebsiteId}

				refreshKey={jobsRefreshKey}

				onOpenGenerate={() => setGenerateModalOpen(true)}

			/>

		</div>

	);

};



export default AiVisibilitySchemaOptimizer;

